<template>
  <div>
    <user-detail-title
      first-bread="图片信息"
      second-bread="图片信息"
      third-bread="图片信息查看"
      first-url="/user/pic"
      second-url="/user/pic_info"
      title-name="图片信息查看"
    ></user-detail-title>
    <user-detail-base style="width: 60%;">
      <el-form label-position="left" label-width="100px" v-if="LookData">
        <el-form-item label="图片">
          <el-image class="item-image" :src="'http://'+LookData.address" alt=""></el-image>
        </el-form-item>
        <el-form-item label="所属类型">
          <span>{{LookData.typeStr}}</span>
        </el-form-item>
        <el-form-item label="是否首页显示">
          <el-switch
            :value="LookData.isHomeShow"
            active-color="#13ce66"
            inactive-color="#ff4949">
          </el-switch>
        </el-form-item>
      </el-form>
    </user-detail-base>
  </div>
</template>

<script>
  import UserDetailTitle from "../Common/UserDetailTitle";
  import UserDetailBase from "../Common/UserDetailBase";
  export default {
    name: "PicInfoLook",
    components: {UserDetailBase, UserDetailTitle},
    data(){
      return{
        LookData:null,
      }
    },
    created() {
      this.GetLookData(this.$route.params.id)
    },
    methods:{
      GetLookData(id){
        this.$axios.get('/api/photo/getById',{params:{
          id:id
          }}).then(res=>{
          this.LookData=res.data.data
        })
      }
    }
  }
</script>

<style scoped>

</style>